import config from 'constants/config'
import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIsMobileOrTablet } from 'hooks/useIsMobileOrTablet'
import { canAccessStaffChat } from 'tripPlanner/utils/staffChatAccess'

export function canUseTripChatMobile({
  accountEmail,
  isTripChatMobileEnabled,
}: {
  accountEmail?: string
  isTripChatMobileEnabled: boolean
}): boolean {
  return isTripChatMobileEnabled || canAccessStaffChat(accountEmail)
}

export function useCanAccessMobileChat(): boolean {
  const isMobileOrTablet = useIsMobileOrTablet()
  const accountEmail = useAppSelector(state => state.auth.account.email)
  const isStaffBypass = canAccessStaffChat(accountEmail)
  const { isAnyVariant: isTripChatMobileEnabled } = useExperiment(
    Experiments.tripChatMobile,
    {
      canActivate: config.ENABLE_TRIP_PLANNER && isMobileOrTablet && !isStaffBypass,
    },
  )

  if (!config.ENABLE_TRIP_PLANNER) {
    return false
  }

  return canUseTripChatMobile({
    accountEmail,
    isTripChatMobileEnabled,
  })
}

/**
 * On LE desktop we always route users to the chat trip planner. Mobile/tablet
 * chat access requires either the `trip_chat_mobile` experiment variant or the
 * staff email allowlist. Brands without trip planner get `false` so consumers
 * hide any trip-planning UI entirely.
 */
export default function useShouldUseChat(): boolean {
  const isMobileOrTablet = useIsMobileOrTablet()
  const canAccessMobileChat = useCanAccessMobileChat()

  if (!config.ENABLE_TRIP_PLANNER) {
    return false
  }

  if (isMobileOrTablet) {
    return canAccessMobileChat
  }

  return true
}
